<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="login-image">
        <img src="@/assets/img/tam/login.png" alt="Login Image" class="login-img">
      </div>
      <div class="login-form">
        <md-card>
          <!-- Encabezado integrado arriba del formulario -->
          <div class="form-header">Sistema SAT</div>
          <md-card-header class="bg-primary">
            <div class="md-title">Iniciar Sesión</div>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label>Email</label>
              <md-input v-model="email" type="email" required />
            </md-field>
            <md-field>
              <label>Contraseña</label>
              <md-input v-model="password" type="password" required />
            </md-field>
            <div v-if="error" class="md-error-text">{{ error }}</div>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-primary md-raised login-btn" @click="login">
              Ingresar
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      email: '',
      password: '',
      error: ''
    };
  },
  methods: {
    login() {
      if (!this.email || !this.password) {
        this.error = 'Todos los campos son obligatorios';
        return;
      }
      this.error = '';
      fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/login/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          correo: this.email,
          password: this.password
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            localStorage.setItem("authToken", data.token);
            localStorage.setItem("usuario", JSON.stringify(data.usuario));
            // Guarda el tiempo de expiración del token.
            // El router.beforeEach lo usará para verificar la validez.
            const expirationTime = data.exp * 1000; // Exp en ms
            localStorage.setItem("tokenExpiry", expirationTime);

            // Solo redirige si el login fue exitoso.
            // El router.beforeEach se encargará de cualquier expiración futura.
            if (this.$route.name !== "Inicio") {
              this.$router.push({ name: "Inicio" });
            }
          } else {
            this.error = data.message;
          }
        })
        .catch(error => {
          console.error("Error en la petición de login:", error);// eslint-disable-line no-console
          this.error = "Error al conectar con el servidor. Inténtalo de nuevo.";
        });
    }
  }
};

</script>

<style scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Fondo con imagen y gradiente overlay */
  background: linear-gradient(rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4)),
    url('@/assets/img/tam/logo.jpg') no-repeat center center;
  background-size: cover;
}

.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 850px;
  background-color: rgba(255, 255, 255, 0.144);
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin: 0 20px;
}

.login-image {
  border-radius: 10px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00000000;

}

.login-img {
  width: 80%;
  height: auto;
  object-fit: cover;
  opacity: 0.8;
  border-radius: 10px;
  /* Borde redondeado */
}

.login-form {
  flex: 1;
  padding: 40px;
}

.md-card {
  background: transparent;
  box-shadow: none;
}

.bg-primary {
  background-color: #1565c0;
  color: #fff;
  text-align: center;
  padding: 15px 0;
}

.md-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.md-field {
  margin-bottom: 20px;
}

.login-btn {
  width: 100%;
  transition: background-color 0.3s ease;
}

.login-btn:hover {
  background-color: #0d47a1;
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .login-image {
    display: none;
  }

  .login-form {
    width: 100%;
    padding: 20px;
  }
}

.mobile-header {
  display: none;
}

@media (max-width: 768px) {
  .mobile-header {
    display: block;
    width: 100vw;
    background: #1565c0;
    color: #fff;
    text-align: center;
    font-size: 1.3rem;
    font-weight: bold;
    padding: 16px 0 12px 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    letter-spacing: 1px;
  }

  .login-wrapper {
    padding-top: 60px;
    /* espacio para el header */
  }

  .login-container {
    flex-direction: column;
  }

  .login-image {
    display: none;
  }

  .login-form {
    width: 100%;
    padding: 20px;
  }
}

.form-header {
  width: 100%;
  background: #1565c0;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: bold;
  padding: 16px 0 12px 0;
  letter-spacing: 1px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-bottom: 10px;
}
</style>